export function ShiftStatusBadge({ status }) {
  // Utilizing standard global semantic status configurations
  const map = {
    Active: "bg-[var(--status-published-bg)] text-[var(--status-published-fg)]",
    Inactive: "bg-[var(--status-archived-bg)] text-[var(--status-archived-fg)]",
  };

  const currentStyles = map[status] || "bg-[var(--status-archived-bg)] text-[var(--status-archived-fg)]";

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap tracking-wide ${currentStyles}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}